import Text from 'components/shared/Text'
import Step from 'components/global/Step'
import SelfcareInfo from 'components/global/SelfcareInfo'
import { useResolutions } from 'store/resolutions'
import { FormattedMessage, useIntl } from 'react-intl'
import ManageTickets from './ManageTickets'
import ManageBusTickets from './ManageBusTicket'
import ManageCabanas from './ManageCabanas'
import { useAppSelector } from 'store/hooks'
import { useEffect } from 'react'
import { useSelfcare } from 'store/selfcare-slice/hooks'
import DateOfStay from 'components/shared/DateOfStay'
import { useDispatch } from 'react-redux'
import { setDeliveryType } from 'store/order-slice'
import CabanasAttraction from 'routes/Upsell/CabanasCreator/CabanasAttraction'
import NotFinishedUpsellInfo from 'routes/Upsell/NotFinishedUpsellInfo'
import CancelYourVisitModal from 'routes/selfcare/modals/CancelYourVisitModal'
import { BusTicketAttraction } from 'routes/Upsell/Bus/components/BusTicketAttraction/BusTicketAttraction'
import { setIsCancelYourVisitModalOpen } from 'store/general-slice'
import { CabanaItemType, synchronizeCabanasWithCart } from 'store/cabana-slice'
import { useCabana } from 'store/cabana-slice/hooks'
import { RouteType, synchronizeTicketsWithCart } from 'store/transport-slice'
import ManageTicketsBundles from './ManageTicketsBundles'
import { SelfcareAccomodationEdit } from 'components/global/SelfcareAccomodationEdit'
import ManageSpa from './ManageSpa'
// TODO: module disabled: MEMORY CAPTURE
// import ManageMemoryCapture from './ManageMemoryCapture'
// import { addUpsell } from 'store/upsell-slice'

const ManageOrder = () => {
    const { isTablet } = useResolutions()
    const { formatMessage } = useIntl()
    const { removeShipping, refetchPositions } = useSelfcare()
    const dispatch = useDispatch()

    const { areCabanasProcessing } = useCabana(null)

    const {
        ticketsBundles,
        tickets,
        spa,
        transport,
        cabanas,
        hasAccommodation,
        // TODO: module disabled: MEMORY CAPTURE
        //memoryCapture,
    } = useAppSelector((state) => state.selfcare)
    const {
        busTickets: cartBusTickets,
        cabanas: cartCabanas,
        // TODO: module disabled: MEMORY CAPTURE
        // memoryCapture: cartMemoryCapture,
    } = useAppSelector((state) => state.selfcareCart.items)
    const { dates: parkDates } = useAppSelector((state) => state.ticket)

    const areTicketsBundlesInOrder = ticketsBundles && ticketsBundles.length > 0
    const areTicketsInOrder = tickets && tickets.length > 0
    const isSpaInOrder = !!spa?.length
    const isTransportInOrder = transport && transport.length > 0
    const areCabanasInOrder = cabanas && cabanas.length > 0

    useEffect(() => {
        removeShipping()
        refetchPositions()
        dispatch(setDeliveryType('email'))

        if (cartBusTickets.length) {
            // ignore already existed, but edited cabanas from cart
            // consider only newly added
            const editedBusTickets =
                transport?.map(
                    (orderBusTicket) => orderBusTicket.changes?.detail.boxId
                ) || []
            const onlyNewBusTickets = cartBusTickets.filter(
                ({ detail: { boxId } }) =>
                    boxId && !editedBusTickets.includes(boxId)
            )

            const routesFromCart: RouteType[] = onlyNewBusTickets.map(
                (ticket) => ({
                    ticket,
                    isCompleted: true,
                    isSubmitted: true,
                    duration: '',
                    unitPrice: ticket.unitPrice || null,
                    defaultDates: parkDates,
                    defaultQuantity: 1,
                })
            )

            dispatch(synchronizeTicketsWithCart(routesFromCart))
        }

        // restore cabanas
        if (cartCabanas.length) {
            // ignore already existed, but edited cabanas from cart
            // consider only newly added
            const editedCabanas =
                cabanas?.map(
                    (orderCabana) => orderCabana.changes?.detail.boxId
                ) || []
            const onlyNewCartCabanas = cartCabanas.filter(
                ({ detail: { boxId } }) =>
                    boxId && !editedCabanas.includes(boxId)
            )
            const cabanasToRestoreFromCart: CabanaItemType[] =
                onlyNewCartCabanas.map((cabana) => ({
                    cabana: {
                        ...cabana,
                    },
                    isCompleted: true,
                    isSubmitted: true,
                }))

            dispatch(synchronizeCabanasWithCart(cabanasToRestoreFromCart))
        }

        // TODO: module disabled: MEMORY CAPTURE
        // cartMemoryCapture &&
        //     dispatch(
        //         addUpsell({ data: cartMemoryCapture, type: 'memoryCapture' })
        //     )
    }, [])

    return (
        <Step
            title={formatMessage({
                id: 'selfcare.steps.caption_edit_reservation',
                defaultMessage: 'Edytuj rezerwację',
            })}
            isButtonDisabled={areCabanasProcessing}
            isButtonVisible={true}
        >
            {isTablet && <SelfcareInfo />}

            <DateOfStay
                resetOrder={() => dispatch(setIsCancelYourVisitModalOpen(true))}
            />

            {/* TICKETS BUNDLES and TICKETS */}
            {areTicketsBundlesInOrder && (
                <ManageTicketsBundles bundles={ticketsBundles} />
            )}
            {areTicketsInOrder && <ManageTickets tickets={tickets} />}

            {/* SPA */}
            {isSpaInOrder && <ManageSpa tickets={spa} />}

            {/* TRANSPORT and CABANAS - if exist in original order */}
            {isTransportInOrder && <ManageBusTickets transport={transport} />}
            {areCabanasInOrder && <ManageCabanas tickets={cabanas} />}

            {hasAccommodation && <SelfcareAccomodationEdit />}

            {/* TRANSPORT and CABANAS - otherwise, as an option to add in selfcare */}
            {!isTablet && (!areCabanasInOrder || !isTransportInOrder) && (
                <Text variant="heading3" pt={16}>
                    <FormattedMessage
                        id="global.steps.caption_upsells"
                        defaultMessage="Udogodnienia i atrakcje"
                    />
                </Text>
            )}
            {!isTransportInOrder && <BusTicketAttraction />}
            {!areCabanasInOrder && <CabanasAttraction />}

            {/*TODO: module disabled: MEMORY CAPTURE */}
            {/*{memoryCapture && memoryCapture.length > 0 && (*/}
            {/*    <ManageMemoryCapture tickets={memoryCapture} />*/}
            {/*)}*/}

            <NotFinishedUpsellInfo />
            <CancelYourVisitModal />
        </Step>
    )
}

export default ManageOrder
